exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip-width {\r\n  max-width: 1000px;\n}\n.el-cascader-node__label {\r\n  max-width: 200px;\n}\r\n", ""]);

// exports
